<template>
<div id="arena-backdrop">
    <div ref="arena" id="arena" class="arena" @mousemove="OnMoveMouse" @drag="OnMoveMouse" :style="{width: `${arenaWidth}px`, height: `${arenaHeight}px`, backgroundImage: 'url(' + require('@/assets/bg.png') + ')'}" @wheel="OnWheel">
        
        <field-card ref="p1Cards" v-for="(img, i) in p1Deck" :key="'p1'+i" 
        :height="cardHeight" 
        :width="cardWidth" 
        :img="img" 
        :uid="'p1-'+i"
        @PreviewCard="OnPreviewCard"></field-card>

        <field-card ref="p2Cards" v-for="(img, i) in p2Deck" :key="'p2-'+i" 
        :height="cardHeight" 
        :width="cardWidth" 
        :img="img" 
        :uid="'p2-'+i"
        @PreviewCard="OnPreviewCard"></field-card>

        <div class="zone-hand p2" :style="{height: `${0.75*cardHeight}px`}">
            <h-zone :uid="`${topPlayer}-mano`" :ref="`${topPlayer}Mano`" :width="cardWidth" :height="cardHeight" private inverted :upTarget="`${topPlayer}-cementerio`" :downTarget="`${topPlayer}-mazo`" :leftTarget="`${topPlayer}-mazo`" :rightTarget="`${topPlayer}-cementerio`"></h-zone>
        </div>
        <cards-pile :uid="`${topPlayer}-reserva`" :ref="`${topPlayer}Reserva`" :height="cardHeight" :width="cardWidth" inverted class="p2-reserva" :downTarget="`${topPlayer}-pagados`"></cards-pile>
        <cards-pile :uid="`${topPlayer}-destierro`" :ref="`${topPlayer}Destierro`" :height="cardHeight" :width="cardWidth" inverted class="p2-destierro" :downTarget="`${topPlayer}-cementerio`"></cards-pile>
        <cards-pile :uid="`${topPlayer}-mazo`" :ref="`${topPlayer}Mazo`" :height="cardHeight" :width="cardWidth" hidden inverted showShuffle class="p2-mazo" :upTarget="`${topPlayer}-mano`" :downTarget="`${topPlayer}-cementerio`" :leftTarget="`${topPlayer}-mano`" :rightTarget="`${topPlayer}-cementerio`"></cards-pile>
        <cards-pile :uid="`${topPlayer}-cementerio`" :ref="`${topPlayer}Cementerio`" :height="cardHeight" :width="cardWidth" inverted class="p2-cementerio" :upTarget="`${topPlayer}-destierro`" :downTarget="`${topPlayer}-mazo`" :leftTarget="`${topPlayer}-mazo`"></cards-pile>
        <cards-pile :uid="`${topPlayer}-pagados`" :ref="`${topPlayer}Pagados`" :height="cardHeight" :width="cardWidth" inverted class="p2-pagados" :upTarget="`${topPlayer}-reserva`"></cards-pile>
        
        <div class="zone-hand p1" :style="{height: `${cardHeight*0.75}px`}">
            <h-zone :uid="`${bottomPlayer}-mano`" :ref="`${bottomPlayer}Mano`" :width="cardWidth" :height="cardHeight" :upTarget="`${bottomPlayer}-mazo`" :downTarget="`${bottomPlayer}-cementerio`" :leftTarget="`${bottomPlayer}-cementerio`" :rightTarget="`${bottomPlayer}-mazo`"></h-zone>
        </div>
        <cards-pile :uid="`${bottomPlayer}-pagados`" :ref="`${bottomPlayer}Pagados`" :height="cardHeight" :width="cardWidth" class="p1-pagados" :downTarget="`${bottomPlayer}-reserva`"></cards-pile>
        <cards-pile :uid="`${bottomPlayer}-cementerio`" :ref="`${bottomPlayer}Cementerio`" :height="cardHeight" :width="cardWidth" class="p1-cementerio" :downTarget="`${bottomPlayer}-destierro`" :upTarget="`${bottomPlayer}-mazo`" :rightTarget="`${bottomPlayer}-mazo`"></cards-pile>
        <cards-pile :uid="`${bottomPlayer}-mazo`" :ref="`${bottomPlayer}Mazo`" :height="cardHeight" :width="cardWidth" hidden showShuffle class="p1-mazo" :downTarget="`${bottomPlayer}-mano`" :upTarget="`${bottomPlayer}-cementerio`" :leftTarget="`${bottomPlayer}-cementerio`" :rightTarget="`${bottomPlayer}-mano`"></cards-pile>
        <cards-pile :uid="`${bottomPlayer}-destierro`" :ref="`${bottomPlayer}Destierro`" :height="cardHeight" :width="cardWidth" class="p1-destierro" :upTarget="`${bottomPlayer}-cementerio`"></cards-pile>
        <cards-pile :uid="`${bottomPlayer}-reserva`" :ref="`${bottomPlayer}Reserva`" :height="cardHeight" :width="cardWidth" class="p1-reserva" :upTarget="`${bottomPlayer}-pagados`"></cards-pile>    

        <div :id="`out-of-bounds-${bottomPlayer}`" style="position: absolute; width: 100%; left: 0; background: red; height: 1000px; top: 100%"></div>
        <div :id="`out-of-bounds-${topPlayer}`" style="position: absolute; width: 100%; left: 0; background: red; height: 1000px; bottom: 100%"></div>

        <div class="cursor" :style="{left: `${p2Cursor.x}%`, top: `${p2Cursor.y}%`, 'margin-left': `${0}px`, 'margin-top': `${0}px`}"><img :src="require('@/assets/cursor2.png')"></div>
        <div class="cursor" :style="{left: `${p1Cursor.x}%`, top: `${p1Cursor.y}%`}"><img :src="require('@/assets/cursor.png')"></div>

        <!--
        <div id="test1" style="width: 100px; height: 100px; background: green; z-index: 3000; position: absolute; left: 50%; top: 50%"></div>
        <div id="test2" style="width: 100px; height: 100px; background: cyan; z-index: 2000; position: absolute; left: 20%; top: 50%"></div>
        -->

    </div>

    <div v-show="!mouseDown && previewImg" class="preview" ref="preview" :style="{left: `${preview.x}px`, top: `${preview.y}px`}">
        <img v-if="previewImg" style="height: 30vw; transform: translate(-50%, -50%); border-radius: 1vw" :src="`http://mylassets.mattkingz.cl/${previewImg}.jpg`">
    </div>

</div>
</template>

<script>
import RowZone from './RowZone.vue'
import FieldCard from './FieldCard.vue'
import CardsPile from './CardsPile.vue'
import HZone from './HZone.vue'
import interact from 'interactjs'
export default {
    components: {RowZone, FieldCard, CardsPile, HZone},
    props: {
        gameData: null,
    },
    data() {
        return {
            arenaWidth: 0,
            arenaHeight: 0,
            cardHeight: 0,
            cardWidth: 0,
            cardRatio: 0.697,
            p1Cursor: {x: 0, y: 0},
            p2Cursor: {x: -100, y: -100},
            mirrored: false,
            preview: {x: 0, y: 0},
            mouseDown: false,
            previewImg: null,
            p1Deck: [],
            p2Deck: [],
            canKeyPress: true,
            canKeyPressTimer: null,
        }
    },
    mounted() {

        this.Resize();
        window.addEventListener('resize', this.Resize);
        //this.$socket.client.io.opts.query = {test: 'hello'};
        //this.$socket.client.connect();

        document.addEventListener("mousedown", this.OnMouseDown);
        document.addEventListener("mouseup", this.OnMouseUp);

        document.addEventListener('keypress', this.OnKeyPress);

        this.SetupGame(this.gameData);

        interact('#out-of-bounds-p1').dropzone({
            ondrop: (event) => {
                this.$refs.p1Mano.OnDrop(event);
            }
        });
        interact('#out-of-bounds-p2').dropzone({
            ondrop: (event) => {
                this.$refs.p2Mano.OnDrop(event);
            }
        });

        /*
        interact(document.getElementById("test2")).draggable({
            listeners: {
                start (event) {
                    console.log(event.type, event.target)
                },
                move (event) {
                    console.log(event);
                    event.target.style.left = `${event.client.x}px`;
                    event.target.style.top = `${event.client.y}px`;
                }
            }
        })

        interact('#test1').dropzone({
            ondrop: function (event) {
            alert(event.relatedTarget.id
                    + ' was dropped into '
                    + event.target.id)
            }
        })
        .on('dropactivate', function (event) {
            event.target.classList.add('drop-activated')
        })
        */
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.Resize);
        document.removeEventListener("mousedown", this.OnMouseDown);
        document.removeEventListener("mouseup", this.OnMouseUp);
        document.removeEventListener('keypress', this.OnKeyPress);
    },
    methods: {
        SetupGame(gameData) {

            let refs = ['p1Mano', 'p1Mazo', 'p1Reserva', 'p1Pagados', 'p1Cementerio', 'p1Destierro',
                'p2Mano', 'p2Mazo', 'p2Reserva', 'p2Pagados', 'p2Cementerio', 'p2Destierro'];
            refs.forEach(ref => {
                this.$refs[ref].Reset();
            });

            this.mirrored = gameData.player == 'p2';
            this.p1Deck = gameData.p1_deck ? gameData.p1_deck : [];
            this.p2Deck = gameData.p2_deck ? gameData.p2_deck : [];
            //console.log(gameData);

            setTimeout(() => {
                if(this.$refs.p1Cards)
                {
                    this.$refs.p1Cards.forEach(card => {
                        this.$refs.p1Mazo.AttachCard(card);
                    });
                }
                if(this.$refs.p2Cards)
                {
                    this.$refs.p2Cards.forEach(card => {
                        this.$refs.p2Mazo.AttachCard(card);
                    });
                }
            }, 200);
        },
        Resize() {
            let rect = this.$el.getBoundingClientRect();
            //console.log(rect);
            this.arenaWidth = rect.width;
            this.arenaHeight = rect.width * 0.5625;
            if(rect.width > rect.height && this.arenaHeight > rect.height)
            {
                this.arenaWidth = rect.height * 1.777777777777778;
                this.arenaHeight = rect.height;
            }

            setTimeout(() => {
                
            
            let rectArena = this.$refs.arena.getBoundingClientRect();
            
            let height = (rectArena.height / 2) / 4;
            this.cardHeight = height;
            this.cardWidth = height * this.cardRatio;
            })


        },
        OnMoveMouse(e) {
            let rectWindow = this.$el.getBoundingClientRect();
            let rect = this.$refs.arena.getBoundingClientRect();

            //preview card
            let rectPreview = this.$refs.preview.getBoundingClientRect();
            let previewW = rectPreview.width / 2;
            let previewH = rectPreview.height / 2;
            let previewX = e.x;
            let previewY = e.y;

            if(previewX - previewW < 0) previewX = previewW;
            if(previewY - previewH < 0) previewY = previewH;
            if(previewX + previewW > rectWindow.width) previewX = rectWindow.width - previewW;
            if(previewY + previewH > rectWindow.height) previewY = rectWindow.height - previewH;

            this.preview = {x: previewX, y: previewY};

            this.p1Cursor = {
                x: ((e.x - rect.x) / rect.width) * 100, 
                y: ((e.y - rect.y) / rect.height) * 100,
                clientX: e.x,
                clientY: e.y
            };
            this.$socket.client.emit('CursorMoved', this.p1Cursor);
        },
        OnMouseDown() {
            this.mouseDown = true;
            this.previewImg = null;
        },
        OnMouseUp() {
            this.mouseDown = false;
        },
        OnPreviewCard(e) {
            this.previewImg = e;
        },
        OnWheel(e) {

            if(e.skipTimeout !== true)
            {
                if(!this.canKeyPress) return;
                this.canKeyPress = false;
                if(this.canKeyPressTimer) clearTimeout(this.canKeyPressTimer);
                this.canKeyPressTimer = setTimeout(() => {
                    this.canKeyPress = true;
                }, 80);
            }

            let card = document.elementFromPoint(e.x, e.y);
            if(!card.__vue__) return;
            card = card.__vue__;
            if(!card.parent) return;

            this.previewImg = null;
            this.$nextTick(() => {this.previewImg = null});

            let target = null;

            //move down
            if(e.deltaY > 0 && card.parent.downTarget)
                target = document.getElementById(card.parent.downTarget);
            if(e.deltaY < 0 && card.parent.upTarget)
                target = document.getElementById(card.parent.upTarget);
            if(e.deltaX > 0 && card.parent.rightTarget)
                target = document.getElementById(card.parent.rightTarget);
            if(e.deltaX < 0 && card.parent.leftTarget)
                target = document.getElementById(card.parent.leftTarget);
            
            if(target && target.__vue__)
            {
                target = target.__vue__;
                this.$socket.client.emit('DeattachCard', {parent: card.parent.uid, card: card.uid});
                card.parent.DeattachCard(card);
                target.OnDrop({relatedTarget: card.$el, autoIndex: true});
            }
        },
        OnKeyPress(e) 
        {
            if(!this.canKeyPress) return;
            this.canKeyPress = false;
            if(this.canKeyPressTimer) clearTimeout(this.canKeyPressTimer);
            this.canKeyPressTimer = setTimeout(() => {
                this.canKeyPress = true;
            }, 80);
            //console.log(e);
            let card = document.elementFromPoint(this.p1Cursor.clientX, this.p1Cursor.clientY);
            if(!card.__vue__) return;
            card = card.__vue__;
            if(!card.parent) return;
            let parent = card.parent;
            if(e.key == 'e' && parent.ToggleList) parent.ToggleList(); 
            if(e.key == 'r' && parent.Shuffle) parent.Shuffle(); 
            if(e.key == 'q' && parent.TogglePileVisibility) parent.TogglePileVisibility();
            if(e.key == 'q' && parent.ToggleZoneVisibility) parent.ToggleZoneVisibility();
            if(e.key == 'w') this.OnWheel({deltaY: -1, deltaX: 0, x: this.p1Cursor.clientX, y: this.p1Cursor.clientY, skipTimeout: true});
            if(e.key == 's') this.OnWheel({deltaY: 1, deltaX: 0, x: this.p1Cursor.clientX, y: this.p1Cursor.clientY, skipTimeout: true});
            if(e.key == 'a') this.OnWheel({deltaX: -1, deltaY: 0, x: this.p1Cursor.clientX, y: this.p1Cursor.clientY, skipTimeout: true});
            if(e.key == 'd') this.OnWheel({deltaX: 1, deltaY: 0, x: this.p1Cursor.clientX, y: this.p1Cursor.clientY, skipTimeout: true});
            this.previewImg = null;
            setTimeout(() => {this.previewImg = null}, 5);

        }
    },
    computed: {
        bottomPlayer() {
            return this.mirrored ? 'p2' : 'p1';
        },
        topPlayer() {
            return this.mirrored ? 'p1' : 'p2';
        },
    },
    sockets: {
        MoveRemoteCursor(data) {
            let rect = this.$refs.arena.getBoundingClientRect();
            data.x = 100-data.x;
            data.y = 100-data.y;
            this.p2Cursor = data;
        },
        MoveRemoteCard(data) {
            let card = document.getElementById(data.id);
            if(card)
            {
                //console.log("move!");
                
                card.classList.add('no-transition');
                card.__vue__.Move(data.x, data.y, null, null, true);
            }
        },
        AttachCardRemote(data) {
            let parent = document.getElementById(data.parent);
            let card = document.getElementById(data.card);
            console.log(data);
            if(parent && card)
            {
                console.log("attach!");
                parent.__vue__.AttachCard(card.__vue__, data.index);
            }
        },
        DeattachCardRemote(data) {
            let parent = document.getElementById(data.parent);
            let card = document.getElementById(data.card);
            console.log(data);
            if(parent && card)
            {
                console.log("deattach!");
                parent.__vue__.DeattachCard(card.__vue__);
            }
        },
        HideCardRemote(data) {
            let card = document.getElementById(data.id);
            console.log(data);
            if(card)
            {
                console.log("hide!");
                card.__vue__.hidden = data.hidden;
            }
        },
        ShowZoneRemote(data) {
            let zone = document.getElementById(data.id);
            console.log(data);
            if(zone)
            {
                console.log("show zone!");
                zone.__vue__.showZone = data.show;
                zone.__vue__.Update();
            }
        },
        ShowPileRemote(data) {
            let pile = document.getElementById(data.id);
            console.log(data);
            if(pile)
            {
                console.log("show pile!");
                if(data.show) 
                    pile.classList.add('show');
                else
                    pile.classList.remove('show');
            }
        },
        ShufflePileRemote(data) {
            let pile = document.getElementById(data.id);
            console.log(data);
            if(pile)
            {
                console.log("shuffle pile!");
                pile.__vue__.ShuffleByIds(data.order);
            }
        },
        JoinedGame(data) {
            if(data.p1_deck) data.p1_deck = data.p1_deck.split(/,/g);
		    if(data.p2_deck) data.p2_deck = data.p2_deck.split(/,/g);
            console.log('JOINED SECOND');
            this.SetupGame(data);
        },
        AttachPileRemote(data) {
            let targetPile = document.getElementById(data.target);
            let pile = document.getElementById(data.pile);
            if(pile && targetPile)
            {
                console.log("attach pile!");
                targetPile.__vue__.AttachPile(pile.__vue__);
            }
        },
        MovePileRemote(data) {
            let pile = document.getElementById(data.id);
            if(pile)
            {
                if(data.position)
                {
                    data.position.x = 100 - data.position.x;
                    data.position.y = 100 - data.position.y;
                }
                pile.__vue__.dragPosition = data.position;
            }
        }
    }
}
</script>

<style>

#arena-backdrop {
    width: 100%;
    height: 100%;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
}

.arena {
    flex-shrink: 0;
    background-color: gray;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    background-size: 100%;
    cursor: none !important;
}

.player-zone {
    height: 50%;
    display: flex;
    flex-direction: column;
}

.zone-row {
    height: 25%;
    display: flex;
}

.cursor {
    position: absolute;
    width: 20px;
    height: 20px;
    z-index: 999998;
    pointer-events: none;
}


.preview {
    position: absolute;
    z-index: 999999;
    pointer-events: none;
}

.zone-hand {
    position: absolute; 
    left: 0; 
    width: 100%;
}
.zone-hand.p1 {
    bottom: 0%;
}
.zone-hand.p2 {
    top: 0%;
}

.p1-destierro {
    position: absolute;
    left: 1%;
    bottom: 11%;
}
.p1-reserva {
    position: absolute;
    left: 7%;
    bottom: 11%;
}
.p1-cementerio {
    position: absolute;
    left: 1%;
    bottom: 25%;
}
.p1-mazo {
    position: absolute;
    left: 7%;
    bottom: 25%;
}
.p1-pagados {
    position: absolute;
    left: 7%;
    bottom: 39%;
}

.p2-destierro {
    position: absolute;
    right: 1%;
    top: 11%;
}
.p2-reserva {
    position: absolute;
    right: 7%;
    top: 11%;
}
.p2-cementerio {
    position: absolute;
    right: 1%;
    top: 25%;
}
.p2-mazo {
    position: absolute;
    right: 7%;
    top: 25%;
}
.p2-pagados {
    position: absolute;
    right: 7%;
    top: 39%;
}


</style>